import { EnumFeatureFlagName, EnumKycStatus } from '@blank/api'
import { Corporate } from 'modules/corporate/types/corporates'
import { useFeatureFlagQuery } from 'modules/corporate/queries/useFeatureFlagQuery'
import { useEffect } from 'react'
import { useFatcaRefusedAccountModal } from '../modals/useFatcaRefusedAccountModal/useFatcaRefusedAccountModal'

interface Props {
  corporate: Corporate | undefined
}

export const useDisplayFatcaRefusedModalOnMount = ({ corporate }: Props) => {
  const { showModal } = useFatcaRefusedAccountModal()
  const { data: usPersonUbbleDetectionFeatureFlag } = useFeatureFlagQuery(
    EnumFeatureFlagName.US_PERSON_UBBLE_DETECTION
  )

  const hasRefusedFiscalityStatus =
    corporate?.statuses?.fiscality === EnumKycStatus.REFUSED

  const isUSPersonDetected =
    corporate?.requester?.identity?.isUSPersonDetected === true
  const isFatcaBlockingModalEnabled =
    usPersonUbbleDetectionFeatureFlag?.body.enabled === true

  const shouldDisplayFatcaRefusedModal =
    isFatcaBlockingModalEnabled &&
    hasRefusedFiscalityStatus &&
    isUSPersonDetected

  useEffect(() => {
    if (shouldDisplayFatcaRefusedModal) {
      showModal()
    }
  }, [shouldDisplayFatcaRefusedModal, showModal])
}
